import { Divider } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import SubHeader from '../../../../components/SubHeader';
import { formatarCnpjCpfIMask } from '../../../../helpers/formatador';
import { getColumns } from './columns';
import { Card, Table } from './styles';

export default function TabEmpresa({
  arrayClientesMatriz,
  arrayClientesPagadores,
}) {
  const renderCard = (title, arrayClientes, type) => (
    <Card className="pr-40 pl-40">
      <SubHeader title={title} />
      {arrayClientes && arrayClientes.length >= 1 ? (
        <Table
          bordered
          columns={getColumns(type)}
          dataSource={arrayClientes.map((item, index) => ({
            ...item,
            key: `${item.id}_${index}`,
            cnpj:
              type === 'matriz'
                ? formatarCnpjCpfIMask(item.cnpj_resumido).concat('/****-**')
                : formatarCnpjCpfIMask(item.cnpj),
          }))}
          pagination={false}
        />
      ) : (
        <>Nenhum resultado encontrado</>
      )}
    </Card>
  );

  return (
    <>
      <Divider style={{ marginTop: 42 }} />
      {renderCard('Cliente Matriz', arrayClientesMatriz, 'matriz')}
      <br />
      {renderCard('Cliente Pagadores', arrayClientesPagadores)}
    </>
  );
}

TabEmpresa.propTypes = {
  arrayClientesMatriz: PropTypes.arrayOf(PropTypes.object),
  arrayClientesPagadores: PropTypes.arrayOf(PropTypes.object),
};

TabEmpresa.defaultProps = {
  arrayClientesMatriz: [],
  arrayClientesPagadores: [],
};
